import classNames from 'classnames';
import { FieldError } from 'react-hook-form';
import { isEmpty, get } from 'lodash-es';
import * as React from 'react';

import { autoCompletes, ids, placeholders } from './constants';

interface TextareaOwnProps {
  fieldName: string;
  autoFocus?: boolean;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
  error?: FieldError;
  value?: string;
}

type TextareaProps = TextareaOwnProps;

export const Textarea: React.FC<TextareaProps> = (props) => {
  const { error, fieldName, autoFocus, onBlur, onChange, value } = props;

  const baseClassName = 'form-control textarea';

  const className = classNames(baseClassName, {
    error,
    'has-value': !isEmpty(value),
  });

  return (
    <textarea
      autoFocus={autoFocus}
      name={fieldName}
      className={className}
      id={get(ids, fieldName)}
      placeholder={get(placeholders(), fieldName)}
      autoComplete={get(autoCompletes, fieldName)}
      autoCapitalize="off"
      onBlur={onBlur}
      onChange={onChange}
      value={value}
    />
  );
};
